import { styled } from '@linaria/react';
import { colors, fonts, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  border-top: 1px solid ${colors.borderGrey};
  border-bottom: 1px solid ${colors.borderGrey};
`;

export const Header = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${space[4]} 0;
  background: none;
  border: none;
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
  text-align: left;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const Label = styled.span`
  flex: 1;
`;

export const ChevronIcon = styled.svg<{ $isOpen: boolean }>`
  flex-shrink: 0;
  margin-left: ${space[3]};
  transition: transform 0.25s ease;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(90deg)' : 'rotate(0deg)')};
`;

export const ContentOuter = styled.div<{ $isOpen: boolean }>`
  display: grid;
  grid-template-rows: ${({ $isOpen }) => ($isOpen ? '1fr' : '0fr')};
  transition: grid-template-rows 0.25s ease;
`;

export const ContentInner = styled.div<{ $isOpen: boolean }>`
  overflow: hidden;
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
`;

export const ContentPadding = styled.div`
  padding: ${space[4]} 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  color: ${colors.fontSecondary};
`;
